import { createAsyncState } from '@/app/service/util'

export default createAsyncState({ data: [] })
